var getRadius = function (baseUnit, round) {
    if (round === true)
        return baseUnit + "px";
    if (typeof round === "number")
        return baseUnit * round + "px";
    if (typeof round === "string")
        return round;
    return "";
};
var topLeft = function (baseUnit, size) { return "border-top-left-radius: " + getRadius(baseUnit, size) + ";"; };
var topRight = function (baseUnit, size) { return "border-top-right-radius: " + getRadius(baseUnit, size) + ";"; };
var bottomLeft = function (baseUnit, size) { return "border-bottom-left-radius: " + getRadius(baseUnit, size) + ";"; };
var bottomRight = function (baseUnit, size) { return "border-bottom-right-radius: " + getRadius(baseUnit, size) + ";"; };
var radiusMap = {
    top: function (baseUnit, size) { return "\n    " + topLeft(baseUnit, size) + "\n    " + topRight(baseUnit, size) + "\n  "; },
    left: function (baseUnit, size) { return "\n    " + topLeft(baseUnit, size) + "\n    " + bottomLeft(baseUnit, size) + "\n  "; },
    bottom: function (baseUnit, size) { return "\n    " + bottomLeft(baseUnit, size) + "\n    " + bottomRight(baseUnit, size) + "\n  "; },
    right: function (baseUnit, size) { return "\n    " + topRight(baseUnit, size) + "\n    " + bottomRight(baseUnit, size) + "\n  "; },
    "top-left": topLeft,
    "top-right": topRight,
    "bottom-left": bottomLeft,
    "bottom-right": bottomRight,
};
export default (function (_a) {
    var baseUnit = _a.theme.constants.SIZE_SUB_UNIT, round = _a.round;
    if (!round)
        return "";
    var value = getRadius(baseUnit, round);
    if (value)
        return "border-radius: " + value + ";";
    var side = round.side, _b = round.size, size = _b === void 0 ? 1 : _b;
    return side in radiusMap ? "" + radiusMap[side](baseUnit, size) : "";
});
